module.exports = __webpack_public_path__ + "img/Material_trading_1200x800.68808d4a.png";